import formatDate from '../../helpers/dateFormat';
import dateDifference from '../../helpers/dateDifference';

const filterColumnNames = ["pcid", "project", "system_name", "model", "serial_number", "description", "updating_type", "installation_type", "enclosure_finish",
  "encl_ship_date", "encl_tracking_number", "ship_date", "install_date", "tracking_number", "tech", "start", "warranty_expire_date", "care", "initial_warr_period", "fee",
  "ts_admin_version", "exit_method", "revenue", "gross_margin", "sale_date", "reseller_flag", "orientation", "bomgar", "sched_ship_date", "progress_payments", "pc_dir_id", "CreatedAt",
  "delete__", "wait_to_ship", "ew___restrict", "prop_num", "production", "salesperson", "client_name", "csm", "prop_name", "client_name", "encl_ship_date", "sale_date", "production"]

export const filterProductionSpeedReportData = (obj: any) => {
  const totalProject: string = 'totalProject';
  const yearArray: string = 'yearArray';
  const productionSpeedReportsData: object[] = obj.ProductionSpeedReports;
  const yearList = GetAllUniqueYearFromData(productionSpeedReportsData);
  const productionSpeedFormatedData: object[] = FormatProductionSpeedData(productionSpeedReportsData)
  const filteredProductionSpeedData: object[] = productionSpeedFormatedData.filter((val: any) => {
    const shipYear: string = new Date(val.encl_ship_date).getFullYear().toString();
    const shipMonth: string = new Date(val.encl_ship_date).getMonth().toString();
    if (obj.yearFilter === 'all' && obj.monthFilter === 'all' && obj.salesRepfilter === 'all') {
      return val;
    } else if (obj.yearFilter === 'all' && obj.monthFilter === 'all') {
      return val.salesperson !== undefined && val.salesperson === obj.salesRepfilter;
    } else if (obj.monthFilter === 'all' && obj.salesRepfilter === 'all') {
      return shipYear === obj.yearFilter;
    } else if (obj.yearFilter === 'all' && obj.salesRepfilter === 'all') {
      return shipMonth === obj.monthFilter;
    } else if (obj.yearFilter === 'all') {
      return shipMonth === obj.monthFilter && val.salesperson !== undefined && val.salesperson === obj.salesRepfilter;
    } else if (obj.monthFilter === 'all') {
      return shipYear === obj.yearFilter && val.salesperson !== undefined && val.salesperson === obj.salesRepfilter;
    } else if (obj.salesRepfilter === 'all') {
      return shipYear === obj.yearFilter && shipMonth === obj.monthFilter;
    } else {
      return shipYear === obj.yearFilter && shipMonth === obj.monthFilter && val.salesperson !== undefined && val.salesperson === obj.salesRepfilter;
    }
  })
  const completeProductionSpeedReportData = getAggrData(filteredProductionSpeedData);
  completeProductionSpeedReportData.aggrData[totalProject] = productionSpeedReportsData.length;
  completeProductionSpeedReportData.aggrData[yearArray] = yearList;
  return completeProductionSpeedReportData;
}

export const GetAllUniqueYearFromData = (obj: any) => {
  const yearArray: number[] = [];
  let i: any = 0;
  for (i; i < obj.length; i++) {
    const enclShipFullYear: number = new Date(obj[i].encl_ship_date).getFullYear();
    if (yearArray.indexOf(enclShipFullYear) === -1) {
      yearArray.push(enclShipFullYear)
    }
  }
  const yearArraySorted = yearArray.sort((valueA: any, valueB: any) => {
    if (valueA < valueB) {
      return -1;
    } else if (valueA > valueB) {
      return 1;
    } else {
      return 0
    }
  })
  return yearArraySorted;
}

export const FormatProductionSpeedData = (obj: any) => {
  const newArray: object[] = [];
  let i: any = 0;
  for (i = 0; i < obj.length; i++) {
    const Listings = obj[i];
    if (Listings.encl_ship_date !== '') {
        newArray.push(formateArray(Listings));
    } else {
      console.log(obj[i])
    }
  }
  return newArray;
}

/* tslint:disable */
export const formateArray = (data: any) => {
  const sortedArr: any = {};
  for (const propertyName in data) {
    if (filterColumnNames.indexOf(propertyName) !== -1) {
      // loop through properties
      if (propertyName === "encl_ship_date" || propertyName === "sale_date") {
        if (data[propertyName]) {
          sortedArr[propertyName] = formatDate(data[propertyName]);
        }
        else {
          sortedArr[propertyName] = ""
        }
      } else if (propertyName === "revenue") {
        sortedArr[propertyName] = data[propertyName] !== "" ? parseFloat(data[propertyName]) : 0;
        sortedArr['revenueColumn'] = data[propertyName] !== "" ? "$" + parseFloat(data[propertyName]).toFixed(2) : "$0";
      } else if (propertyName === 'client_name') {
        sortedArr[propertyName] = `${data['prop_name']} ${data['client_name']}`;
        sortedArr['speed'] = (dateDifference(data['sale_date'], data['encl_ship_date']))
      } else if (propertyName === 'client_name') {
        if (data[propertyName]) {
          sortedArr[propertyName] = data[propertyName].trim().replace(/[\/\\]/g, '')
        } else {
          sortedArr[propertyName] = ""
        }
      }
      else {
        sortedArr[propertyName] = data[propertyName];
      }
    }
  }
  return sortedArr;
}

/* tslint:enable */
export const getAggrData = (data: any) => {
  let totalRevenue: number = 0;
  let curruntMonthUnits: number = 0;
  let currentMonthRevenue: number = 0;
  let currentMonthUnitRatioToTotal: number = 0;
  let currentMonthRevenueRatioToTotal: number = 0;
  let prevMonthUnits: number = 0;
  let prevMonthRevenue: number = 0;
  let prevMonthUnitRatioToTotal: number = 0;
  let prevMonthRevenueRatioToTotal: number = 0;
  let twoMonthPrevUnits: number = 0;
  let twoMonthPrevRevenue: number = 0;
  let twoMonthPrevUnitRatioToTotal: number = 0;
  let twoMonthPrevRevenueRatioToTotal: number = 0;
  let restMonthUnits: number = 0;
  let restMonthRevenue: number = 0;
  let restMonthUnitRatioToTotal: number = 0;
  let restMonthRevenueRatioToTotal: number = 0;
  let summationAllSpeed: number = 0;
  let averageAllTheSpeed: number = 0;

  let i: any = 0;
  for (i; i < data.length; i++) {
    const enclShipFullYear: number = new Date(data[i].encl_ship_date).getFullYear();
    const enclShipMonth: number = new Date(data[i].encl_ship_date).getMonth();
    const saleFullYear: number = new Date(data[i].sale_date).getFullYear();
    const SaleMonth: number = new Date(data[i].sale_date).getMonth();
    const currentSaleMonth: string = saleFullYear + "-" + (SaleMonth + 1)
    const prevMonthOfCurrentShipMonth: string = enclShipMonth === 0 ? (enclShipFullYear - 1) + "-" + 12 : enclShipFullYear + "-" + enclShipMonth;
    const prevTwoMonthOfCurrntShipMonth: string = getPrevTwoMonthOfCurrntShipMonth(enclShipFullYear, enclShipMonth)

    if (enclShipFullYear === saleFullYear && enclShipMonth === SaleMonth) {
      curruntMonthUnits = curruntMonthUnits + 1;
      currentMonthRevenue = currentMonthRevenue + data[i].revenue;
    } else if (currentSaleMonth === prevMonthOfCurrentShipMonth) {
      prevMonthUnits = prevMonthUnits + 1;
      prevMonthRevenue = prevMonthRevenue + data[i].revenue;
    } else if (currentSaleMonth === prevTwoMonthOfCurrntShipMonth) {
      twoMonthPrevUnits = twoMonthPrevUnits + 1;
      twoMonthPrevRevenue = twoMonthPrevRevenue + data[i].revenue;
    } else {
      restMonthUnits = restMonthUnits + 1;
      restMonthRevenue = restMonthRevenue + data[i].revenue;
    }  
  
    if(data[i].speed !== "") {
      summationAllSpeed = summationAllSpeed + parseInt(data[i].speed.split(" ")[0], 10);
    }   
  }

  totalRevenue = currentMonthRevenue + prevMonthRevenue + twoMonthPrevRevenue + restMonthRevenue;
  currentMonthUnitRatioToTotal = (curruntMonthUnits / data.length) * 100;
  currentMonthRevenueRatioToTotal = (currentMonthRevenue / totalRevenue) * 100;
  prevMonthUnitRatioToTotal = (prevMonthUnits / data.length) * 100;
  prevMonthRevenueRatioToTotal = (prevMonthRevenue / totalRevenue) * 100;
  twoMonthPrevUnitRatioToTotal = (twoMonthPrevUnits / data.length) * 100;
  twoMonthPrevRevenueRatioToTotal = (twoMonthPrevRevenue / totalRevenue) * 100;
  restMonthUnitRatioToTotal = (restMonthUnits / data.length) * 100;
  restMonthRevenueRatioToTotal = (restMonthRevenue / totalRevenue) * 100;
  averageAllTheSpeed = summationAllSpeed/data.length;

  return {
    'data': data,
    'aggrData': {
      'totalRevenue': totalRevenue,
      'totalUnit': data.length,
      'curruntMonthUnits': curruntMonthUnits,
      'currentMonthRevenue': currentMonthRevenue,
      'currentMonthUnitRatioToTotal': isNaN(currentMonthUnitRatioToTotal) || currentMonthUnitRatioToTotal === Infinity ? 0 : currentMonthUnitRatioToTotal.toFixed(2),
      'currentMonthRevenueRatioToTotal': isNaN(currentMonthRevenueRatioToTotal) || currentMonthRevenueRatioToTotal === Infinity ? 0 : currentMonthRevenueRatioToTotal.toFixed(2),
      'prevMonthUnits': prevMonthUnits,
      'prevMonthRevenue': prevMonthRevenue,
      'prevMonthUnitRatioToTotal': isNaN(prevMonthUnitRatioToTotal) || prevMonthUnitRatioToTotal === Infinity ? 0 : prevMonthUnitRatioToTotal.toFixed(2),
      'prevMonthRevenueRatioToTotal': isNaN(prevMonthRevenueRatioToTotal) || prevMonthRevenueRatioToTotal === Infinity ? 0 : prevMonthRevenueRatioToTotal.toFixed(2),
      'twoMonthPrevUnits': twoMonthPrevUnits,
      'twoMonthPrevRevenue': twoMonthPrevRevenue,
      'twoMonthPrevUnitRatioToTotal': isNaN(twoMonthPrevUnitRatioToTotal) || twoMonthPrevUnitRatioToTotal === Infinity ? 0 : twoMonthPrevUnitRatioToTotal.toFixed(2),
      'twoMonthPrevRevenueRatioToTotal': isNaN(twoMonthPrevRevenueRatioToTotal) || twoMonthPrevRevenueRatioToTotal === Infinity ? 0 : twoMonthPrevRevenueRatioToTotal.toFixed(2),
      'restMonthUnits': restMonthUnits,
      'restMonthRevenue': restMonthRevenue,
      'restMonthUnitRatioToTotal': isNaN(restMonthUnitRatioToTotal) || restMonthUnitRatioToTotal === Infinity ? 0 : restMonthUnitRatioToTotal.toFixed(2),
      'restMonthRevenueRatioToTotal': isNaN(restMonthRevenueRatioToTotal) || restMonthRevenueRatioToTotal === Infinity ? 0 : restMonthRevenueRatioToTotal.toFixed(2),
      'avgSpeed': isNaN(averageAllTheSpeed) ? 0 : Math.floor(averageAllTheSpeed)
    }
  }
}

export const getPrevTwoMonthOfCurrntShipMonth = (enclShipFullYear: number, enclShipMonth: number) => {
  if (enclShipMonth === 0) {
    return (enclShipFullYear - 1) + "-" + 11
  } else if (enclShipMonth === 1) {
    return (enclShipFullYear - 1) + "-" + 12
  } else {
    return enclShipFullYear + "-" + (enclShipMonth - 1)
  }
}

export const getSalesRepData = (obj: any) => {
  return obj.salesRepData;
};



// WEBPACK FOOTER //
// ./src/store/productionSpeed/productionSpeedFilters.ts